import OverviewManager from "../admin/OverviewManager";

export default function Dashboard() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <OverviewManager />
      </div>
    </>
  );
}
